import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  .algolia-autocomplete .algolia-docsearch-suggestion--highlight {\n    color: doc-search-suggestion-highlight-on-background;\n    background-color: doc-search-suggestion-highlight-background;\n  }\n\n  .algolia-autocomplete .algolia-docsearch-suggestion--text .algolia-docsearch-suggestion--highlight {\n    box-shadow: inset 0 -2px 0 0 ", ";\n  }\n\n  .algolia-autocomplete .ds-cursor .algolia-docsearch-suggestion--content {\n    background-color: doc-search-suggestion-content-background !important;\n  }\n\n  .algolia-autocomplete .ds-dropdown-menu [class^=ds-dataset-] {\n    background-color: background;\n    border-color: layout-border;\n  }\n\n  .algolia-autocomplete .ds-dropdown-menu:before {\n    background-color: background;\n    border-color: layout-border;\n  }\n\n  .algolia-autocomplete .algolia-docsearch-suggestion {\n    background-color: background;\n    color: on-background;\n  }\n\n  .algolia-autocomplete .algolia-docsearch-suggestion--category-header {\n    border-color: layout-border;\n    color: on-background-light;\n  }\n\n  .algolia-autocomplete .algolia-docsearch-suggestion--title {\n    color: on-background;\n  }\n\n  .algolia-autocomplete .algolia-docsearch-suggestion--subcategory-column {\n    color: on-background-light;\n  }\n\n  .algolia-autocomplete .algolia-docsearch-suggestion--text {\n    color: on-background-light;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { Box, createGlobalStyle, th } from '@xstyled/styled-components';
import { RiSearchEyeLine } from 'react-icons/ri';
import { Input, InputGroup, InputGroupIcon } from './Input';
var DocSearchStyle = createGlobalStyle(_templateObject(), th.color('doc-search-suggestion-content-underline'));
export function DocSearch(_ref) {
  var apiKey = _ref.apiKey,
      indexName = _ref.indexName;
  React.useEffect(function () {
    window.docsearch({
      apiKey: apiKey,
      indexName: indexName,
      inputSelector: '#algolia-docsearch-input',
      debug: true
    });
  }, [apiKey, indexName]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DocSearchStyle, null), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(InputGroup, null, /*#__PURE__*/React.createElement(InputGroupIcon, null, /*#__PURE__*/React.createElement(RiSearchEyeLine, null)), /*#__PURE__*/React.createElement(Input, {
    id: "algolia-docsearch-input",
    type: "search",
    placeholder: "Search..."
  }))));
}